export const ExternalProviderEnumArray = ['google', 'facebook', 'mooney'] as const
export type ExternalProviderEnum = (typeof ExternalProviderEnumArray)[number]
